module.exports = __webpack_public_path__ + "img/refresh.5d904f1e.png";